import { Anchor, Group } from "@mantine/core";
import { PUBLIC_ROUTES } from "../../routes";
import { SiteName } from "../../utils/enums";

declare const BACKEND_BASE_URL: string | undefined;

const BASE_URL = BACKEND_BASE_URL || "";

export interface FooterMenuProps {
  siteName: SiteName;
  strongLinks?: boolean;
}

const links: {
  url: string;
  label: string;
  siteNames: ReadonlyArray<SiteName>;
}[] = [
  {
    url: PUBLIC_ROUTES.support,
    label: "Support",
    siteNames: [SiteName.Smarendo, SiteName.Optinode]
  },
  {
    url: "https://www.node.energy/legal/agb",
    label: "AGB",
    siteNames: [SiteName.Optinode]
  },
  {
    url: `${BASE_URL}/seiten/datenschutz`,
    label: "Datenschutz",
    siteNames: [SiteName.Smarendo]
  },
  {
    url: "https://www.node.energy/legal/avv",
    label: "Datenschutz",
    siteNames: [SiteName.Optinode]
  },
  {
    url: `${BASE_URL}/seiten/impressum`,
    label: "Impressum",
    siteNames: [SiteName.Smarendo, SiteName.Optinode]
  },
  {
    url: "https://www.roedl.de/",
    label: "Homepage",
    siteNames: [SiteName.Smarendo]
  },
  {
    url: "https://node.energy/",
    label: "Homepage",
    siteNames: [SiteName.Optinode]
  },
  {
    url: "https://www.alva-energie.de/impressum",
    label: "Impressum",
    siteNames: [SiteName.Alva]
  },
  {
    url: "https://www.alva-energie.de/datenschutz",
    label: "Datenschutz",
    siteNames: [SiteName.Alva]
  }
];

function FooterMenu({ siteName, strongLinks = false }: FooterMenuProps) {
  return (
    <Group className="FooterMenu" mt="xl" wrap="nowrap">
      {links
        .filter(({ siteNames }) => siteNames.includes(siteName))
        .map(({ url, label }) => (
          <Anchor
            c="#6f727d"
            fw={strongLinks ? 500 : 400}
            href={url}
            key={label}
            rel="noopener noreferrer"
            target="_blank"
            underline="never"
          >
            {label}
          </Anchor>
        ))}
    </Group>
  );
}

export { FooterMenu };
